import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import PremiumIconOne from "../assets/img/badge-1.png";
import PremiumIconTwo from "../assets/img/badge-2.png";
import PremiumIconThree from "../assets/img/badge-3.png";

import PackageName from "../assets/img/package-name.png";
import ConfirmBuyModal from "./ConfirmBuyModal";

const packages = [
  { name: "Cosmic Dust", price: 10, capping: 100, gradient: "bg-gradient-1" },
  { name: "Stardust Ember", price: 20, capping: 200, gradient: "bg-gradient-2" },
  { name: "Nebula Pulse", price: 50, capping: 500, gradient: "bg-gradient-3" },
  { name: "Astro Shimmer", price: 100, capping: 1000, gradient: "bg-gradient-4" },
  { name: "Lunar Flux", price: 200, capping: 2000, gradient: "bg-gradient-5" },
  { name: "Galaxy Surge", price: 400, capping: 4000, gradient: "bg-gradient-6" },
  {
  name: "Solar Nova",
  price: 600,
  capping: 6000,
  gradient: "bg-gradient-7",
  badge: PremiumIconOne,
  info: (
    <>
      <h4>Solar Nova Package</h4>

      <p>
        Solar Nova offers premium-level rewards with faster growth and extended
        earning potential designed for serious users.
      </p>

      <ul>
        <li>Higher daily earning limit</li>
        <li>Priority reward distribution</li>
        <li>Best suited for long-term users</li>
        <li>Stable and secure returns</li>
      </ul>
    </>
  )
},
  {
    name: "Quantum Star",
    price: 1000,
    capping: 10000,
    gradient: "bg-gradient-8",
    badge: PremiumIconTwo,
    info:(
         <>
      <h4>Quantum Star</h4>

      <p>
       Quantum Star unlocks elite benefits including maximum daily capping and priority earnings distribution.
      </p>

      <ul>
        <li>Higher daily earning limit</li>
        <li>Priority reward distribution</li>
        <li>Best suited for long-term users</li>
        <li>Stable and secure returns</li>
      </ul>
    </>
    ) 
  },
  {
    name: "Celestial Radiance",
    price: 1500,
    capping: 15000,
    gradient: "bg-gradient-9",
    badge: PremiumIconThree,
    info:(
        <>
      <h4>Celestial Radiance</h4>

      <p>
      Celestial Radiance is the highest tier package with ultimate rewards, maximum stability, and long-term earning security.
      </p>

      <ul>
        <li>Higher daily earning limit</li>
        <li>Priority reward distribution</li>
        <li>Best suited for long-term users</li>
        <li>Stable and secure returns</li>
      </ul>
    </>
    ) 
  }
];


const PurchaseCountdown = ({ expiry }) => {
  const calculateTimeLeft = () => {
    const now = Date.now();
    const diff = expiry * 1000 - now;

    if (diff <= 0) {
      return { days: "00", hours: "00", minutes: "00", seconds: "00" };
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return {
      days: String(days).padStart(2, "0"),
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0"),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    if (!expiry) return;

    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, [expiry]);

  return (
    <div className="purchase-countdown">
      <div className="days"><h3>{timeLeft.days}</h3><span>Days</span></div>
      <div className="times"><h3>{timeLeft.hours}</h3><span>Hours</span></div>
      <div className="Minutes"><h3>{timeLeft.minutes}</h3><span>Minutes</span></div>
      <div className="seconds"><h3>{timeLeft.seconds}</h3><span>Seconds</span></div>
    </div>
  );
};


const PackageInfoModal = ({ open, pkg, onClose }) => {
  if (!open || !pkg) return null;

  return (
    <div className="info-modal-overlay" onClick={onClose}>
      <div className="info-modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="info-modal-close" onClick={onClose}>
          <i className="fa-solid fa-xmark"></i>
        </button>
{/* 
        {pkg.badge && (
          <img src={pkg.badge} alt="badge" className="info-modal-badge" />
        )}

        <h2>{pkg.name}</h2>
        <h4>${pkg.price}</h4> */}
        <p>{pkg.info}</p>
      </div>
    </div>
  );
};

const Packages = ({ objPackageDetails, PreAuthorize }) => {
  const [showModal, setShowModal] = useState(false);
const [selectedPackage, setSelectedPackage] = useState(null);
const [statusText, setStatusText] = useState({
  title: "",
  message: "",
  type: "loading", // loading | success | error
});
  const purchasedArray = objPackageDetails?.purchasedPackage ?? Array(packages.length).fill(false);
  const purchasedTimestamp = objPackageDetails?.purchasedTimestamp ?? Array(packages.length).fill(0);
  const expiryTimestamp = objPackageDetails?.expiryTimestamp ?? Array(packages.length).fill(0);
console.log("RAW objPackageDetails 👉", objPackageDetails);

  const lastBoughtIndex = purchasedArray.lastIndexOf(true);
  const nextBuyIndex = purchasedArray.indexOf(false);

  
  const [openInfoIndex, setOpenInfoIndex] = useState(null);

  const toggleInfo = (index) => {
    setOpenInfoIndex(openInfoIndex === index ? null : index);
  };


  const [infoOpen, setInfoOpen] = useState(false);
  const [infoPackage, setInfoPackage] = useState(null);

     objPackageDetails?.purchasedPackage ?? Array(packages.length).fill(false);
   objPackageDetails?.purchasedTimestamp ?? Array(packages.length).fill(0);
    objPackageDetails?.expiryTimestamp ?? Array(packages.length).fill(0);

 
  const openInfo = (pkg) => {
    setInfoPackage(pkg);
    setInfoOpen(true);
  };


  // const handleBuyNow = (pkg, id) => {
  //   console.log("BUY CALL:", pkg.name, id, pkg.price);
  //   // alert(`Package: ${pkg.name}\nID: ${id}\nPrice: $${pkg.price}`);
  //   PreAuthorize(id, pkg.price);
  // };
  const handleBuyNow = (pkg, id) => {
    setSelectedPackage({ ...pkg, id });
    setShowModal(true);
  };

   // ⭐ When modal "Confirm" is clicked
  const handleConfirm = async () => {
  setStatusText({
    visible: true,
    type: "loading",
    title: "Approval Pending…",
    message: "Please approve in Wallet."
  });

  try {
    await PreAuthorize(
      selectedPackage.id,
      selectedPackage.price,
      setStatusText
    );
  } catch (err) {
    setStatusText({
      visible: true,
      type: "error",
      message: err.message || "Something went wrong!"
    });
  }
};


  return (
     <>
      {/* MODAL HERE */}
       {/* CONFIRM BUY MODAL */}
      <ConfirmBuyModal
        open={showModal}
        pkg={selectedPackage}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        status={statusText}
        setStatusText={setStatusText} 
      />

       {/* INFO MODAL OUTSIDE GRID */}
      <PackageInfoModal
        open={infoOpen}
        pkg={infoPackage}
        onClose={() => setInfoOpen(false)}
      />

    
    <section className="package_section">
      <div className="row">
        {packages.map((pkg, idx) => {
          const isPurchased = purchasedArray[idx];
          const expiryTime = expiryTimestamp[idx];

          const isLastBought = idx === lastBoughtIndex;
          const isNextBuy = idx === nextBuyIndex;

          return (
            <div key={idx} className="col-md-6 col-lg-4">
              <div
                className={`packagedivcard video__card
                  ${pkg.gradient}
                  ${isPurchased ? "bought" : ""}
                  ${isNextBuy ? "current-package" : ""}
                  ${!isPurchased && !isNextBuy ? "disabled" : ""}`}
              >
                {isLastBought && (
                  <span className="badge-span-design">
                    <span className="TicketBookname-badge">Current Package</span>
                  </span>
                )}

                <div className="position-relative-package">
                  <span className="top-line spn-bg"></span>
                  <span className="right-line spn-bg"></span>
                  <span className="bottom-line spn-bg"></span>
                  <span className="left-line spn-bg"></span>

                  <div className="circlediv">
                    <span className="cricle-package">
                      <span className="PackageNamepspan">
                        <img src={PackageName} alt="" className="package-icon" />
                      </span>
                    </span>
                  </div>

                  {pkg.badge && (
                    <span className="bdge-premium">
                      <img src={pkg.badge} alt="premium-badge" className="premium-badge" />
                    </span>
                  )}

                  <div className="pakrightdiv">
                    <h3 className="package-amount">${pkg.price}</h3>
                     <h4>
                    {pkg.name}
                    {pkg.info && (
                      <button
                        className="info-btn"
                        onClick={() => openInfo(pkg)}
                      >
                        <i className="fa-solid fa-circle-info"></i>
                      </button>
                    )}
                  </h4>

                    <div className="package-div-row">
                      <div className="capping-span">
                        <span className="me-2">${pkg.capping}</span> Capping
                      </div>
                    </div>

                    {idx === lastBoughtIndex && (
                      <>
                        <div className="Expires-on">Expires on</div>
                        <PurchaseCountdown expiry={expiryTime} />
                      </>
                    )}


                    {/* <div className="Expires-on">Expires on</div>
                    <PurchaseCountdown expiry={expiryTime} /> */}

                    <div className="purchase-time">
                      <span className="Purchased-On">Purchased On</span>
                      <span className="Purchasedlock">
                        <i className="fa-solid fa-clock me-2"></i>
                        {purchasedTimestamp[idx] > 0
                          ? new Date(purchasedTimestamp[idx] * 1000).toLocaleString()
                          : "Not Purchased"}
                      </span>
                    </div>

                    {/* BUY BUTTON FIXED */}
                    {isNextBuy && !isPurchased && (
                      <button
                        className="new_joining_btn new_joining_btn_package btn-blink w-100 mt-2"
                        onClick={() => handleBuyNow(pkg, idx)}
                      >
                        Buy Now (${pkg.price})
                      </button>
                    )}

                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
    </>
  );
};

export default Packages;
